import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { PageHeader } from 'src/components/common/page-header';
import { RestaurantDetails } from 'src/components/manage-restaurants/details/details';
import {
  StoreDetailsDocument,
  StoreDetailsQuery,
} from 'src/graphql/generated/graphql';
import { Routes } from 'src/components/common/router/constants';

export const RestaurantPage = () => {
  const { id } = useParams();
  const { data } = useQuery<StoreDetailsQuery>(StoreDetailsDocument, {
    variables: {
      id: id,
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-and-network',
  });

  const { t } = useTranslation();
  const breadCrumbsProps = {
    items: [
      {
        label: t('manage-restaurants.my-stores', 'Stores'),
        url: Routes.restaurants.path,
      },
      {
        label: t('manage-restaurants.store-details', 'Details'),
      },
    ],
  };

  const title = t('restaurants.store_details', 'Restaurant details');
  const store = data?.storeById;

  return (
    <>
      <PageHeader title={title} breadcrumbs={breadCrumbsProps} />
      {store && <RestaurantDetails store={store} />}
    </>
  );
};

export default RestaurantPage;
